import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { INVENTORY_UPDATED, SOME_WENT_WRONG } from "../../../utlis/messages";

const GET_INVENTORY_LIST = `inventory`;
const UPLOAD_CSV = `inventory/uploadCsv`;
const DOWNLOAD_CSV = `inventory/downloadCsv`;
const UPDATE_INVENTORY = `inventory/update`;
const FETCH_FEED = `inventory/fetchFeed`;


export const FetchInventoryList = createAsyncThunk(
  "FetchInventoryList",
  async ({ page, limit, search = "" }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${GET_INVENTORY_LIST}?page=${page}&limit=${limit}&search=${search}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const uploadInventoryCsv = createAsyncThunk(
  "uploadInventoryCsv",
  async (data: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(UPLOAD_CSV, { data });
      successMessage(response.data.responseMessage);
      dispatch(FetchInventoryList({ page: 1, limit: 10 }));
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const DownloadInventoryList = createAsyncThunk(
  "DownloadInventoryList",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${DOWNLOAD_CSV}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const DeleteInventory = createAsyncThunk(
  "DeleteInventory",
  async ({ id, selectedPage }: { id: string; selectedPage: any }, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).delete(`inventory/${id}`);
      successMessage("Inventory deleted successfully");
      await dispatch(FetchInventoryList({ page: 1, limit: 10 }));

      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetInventoryDetails = createAsyncThunk(
  "inventoryDetails",
  async ({id}: {id: string}, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`inventory/${id}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateInventory = createAsyncThunk(
  "updateInventory",
  async ({ values }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(UPDATE_INVENTORY, values);
      successMessage(response.data?.payload?.responseMessage || INVENTORY_UPDATED);

      await dispatch(FetchInventoryList({ page: 1, limit: 10 }));
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG);

      return rejectWithValue(error.response.data);
    }
  }
);
export const fetchFeedUrl = createAsyncThunk(
  "fetchFeedUrl",
  async ({ url }: { url: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(FETCH_FEED, { url });
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG);
      return rejectWithValue(error?.response?.data);
    }
  }
);

